import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { Event, Sharry, User, Wonder } from 'src/types/graphql';
import { BasePlusComponent } from '../../base/base-plus.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import { NavigationService } from '../../../../common/navigation/navigation.service';
import { PeopleLikesComponent } from '../../people-likes/people-likes.component';
import { HeaderComponent } from '../header.component';
import { RouteTranslatePipe } from '../../../pipes/route-translate.pipe';

@Component({
  selector: 'sharry-header-content',
  standalone: true,
  templateUrl: './header-content.component.html',
  styleUrl: './header-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    HeaderComponent,
    PeopleLikesComponent,
    IconComponent,
    MatButtonModule,
    RouteTranslatePipe,
    RouterLink,
  ],
})
export class HeaderContentComponent extends BasePlusComponent {
  @Input() showFavouriteButton: boolean;
  @Input() showLikeButton: boolean;
  @Input() showShareButton: boolean;
  @Input() content: Partial<Sharry | Wonder | Event | User>;
  @Output() favouriteClicked = new EventEmitter<Partial<User>>();

  constructor(private navigationService: NavigationService) {
    super();
  }

  onBack() {
    this.navigationService.back();
  }
}
